import { render } from "./view-sales.vue?vue&type=template&id=b58dd952&scoped=true"
import script from "./view-sales.vue?vue&type=script&lang=js"
export * from "./view-sales.vue?vue&type=script&lang=js"

import "./view-sales.vue?vue&type=style&index=0&id=b58dd952&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58dd952"]])

export default __exports__